import React from 'react'
import type { KambiEvent, KambiLiveData } from '@mobi/api-types/kambi'
import { CricketLiveDisplay } from './Components/CricketLiveDisplay'
import { ScoreCardDisplay } from './Components/ScoreCardDisplay'
import { ScoreTableDisplay } from './Components/ScoreTableDisplay'

interface Props {
  event: KambiEvent
  clock?: KambiLiveData['matchClock']
  statistics?: KambiLiveData['statistics']
  score?: KambiLiveData['score']
  shouldUseDarkTheme?: boolean
  hasLiveEventFinished?: boolean
}

export const LiveInfoSection: React.FC<Props> = ({
  clock,
  score,
  event,
  statistics,
  shouldUseDarkTheme,
  hasLiveEventFinished,
}) => {
  const sport = event.sport

  if (sport === 'VOLLEYBALL') {
    return (
      <ScoreTableDisplay
        columns={[
          { key: 'sets', label: 'Sets' },
          { key: 'points', label: 'Points' },
        ]}
        event={event}
        score={score}
        statistics={statistics}
        shouldUseDarkTheme={shouldUseDarkTheme}
      />
    )
  }

  if (sport === 'TABLE_TENNIS') {
    return (
      <ScoreTableDisplay
        columns={[
          { key: 'sets', label: 'Sets' },
          { key: 'points', label: 'Points' },
        ]}
        event={event}
        score={score}
        statistics={statistics}
        shouldUseDarkTheme={shouldUseDarkTheme}
      />
    )
  }
  if (sport === 'TENNIS') {
    return (
      <ScoreTableDisplay
        columns={[
          { key: 'sets', label: 'Sets' },
          { key: 'games', label: 'Games' },
          { key: 'points', label: 'Points' },
        ]}
        event={event}
        score={score}
        statistics={statistics}
        shouldUseDarkTheme={shouldUseDarkTheme}
      />
    )
  }

  if (sport === 'CRICKET') {
    return (
      <CricketLiveDisplay event={event} score={score} shouldUseDarkTheme={shouldUseDarkTheme} />
    )
  }

  if (sport === 'COUNTER_STRIKE') {
    return (
      <ScoreCardDisplay event={event} shouldHideClock shouldUseDarkTheme={shouldUseDarkTheme} />
    )
  }

  return (
    <ScoreCardDisplay
      event={event}
      clock={clock}
      score={score}
      shouldUseDarkTheme={shouldUseDarkTheme}
      hasLiveEventFinished={hasLiveEventFinished}
    />
  )
}
